import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LoadingContextType {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const requestCountRef = React.useRef(0);

  const setLoading = (loading: boolean) => {
    if (loading) {
      requestCountRef.current += 1;
      setIsLoading(true);
    } else {
      requestCountRef.current = Math.max(0, requestCountRef.current - 1);
      if (requestCountRef.current === 0) {
        setIsLoading(false);
      }
    }
  };

  return (
    <LoadingContext.Provider value={{ isLoading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

